import PagedCollection        from '@widesk-core/models/PagedCollection';
import StonecodeFileFileModel from '@models/file/StonecodeFileFileModel';
import StonecodeFileTypeModel from '@models/file/StonecodeFileTypeModel';

export default async function uploadFileForModelUrn(
	modelUrn: Urn,
	reference: File_StonecodeFileTypeReference,
	file: File,
) {
	const typeCollection = new PagedCollection(StonecodeFileTypeModel);

	await typeCollection.setRequiredFilter('reference', reference).list();

	const type = typeCollection.first()?.urn;

	// Sans ce garde-fou, l'envoi partait quand même : `patchFormData` retire les valeurs `undefined`
	// de son `FormData` (voir `ApiModel`), le champ `type` disparaissait donc en silence et l'API
	// répondait 400 sans que rien n'explique lequel des deux côtés avait fauté.
	if (!type) {
		throw new Error(`Aucun type de fichier "${reference}" n'est configuré côté API : l'envoi est impossible.`);
	}

	const uploaded = new StonecodeFileFileModel();

	await uploaded.patchFormData({ file, sourceUrn: modelUrn, type });

	return uploaded;
}
